import type { Appointment, Reference } from '@medplum/fhirtypes'
import type { ReactNode } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { AppointmentDetails } from '#src/components/appointment/AppointmentDetails.tsx'
import type { NotificationItem } from '#src/hooks/useNotificationItems.ts'
import { ResourceUnavailable } from '#src/pages/inbox/detail/ResourceUnavailable.tsx'
import { SidebarHeader } from '#src/pages/inbox/detail/SidebarHeader.tsx'

/* Appointment viewer */
export function AppointmentDetailView({
  appointmentRef,
  actionUrl,
  notificationItem,
  onClose,
}: {
  appointmentRef: Reference<Appointment>
  actionUrl: string
  notificationItem: NotificationItem
  onClose: () => void
}): ReactNode {
  return (
    <div className="flex h-full flex-col border-l border-border bg-background">
      <SidebarHeader
        title="New proposed appointment"
        actionUrl={actionUrl}
        actionLabel="Open chart"
        notificationItem={notificationItem}
        onClose={onClose}
      />
      <div className="min-h-0 flex-1">
        <ErrorBoundary fallback={<ResourceUnavailable label="appointment" />}>
          <AppointmentDetails appointmentRef={appointmentRef} />
        </ErrorBoundary>
      </div>
    </div>
  )
}
